import liveswitch from "fm.liveswitch";
import { useState } from "react";
import { Form } from "react-bulma-components";

type Props = {
    label: string;
    inputs: liveswitch.SourceInput[];
    onChange: (input: liveswitch.SourceInput) => Promise<void>;
    defaultValue: string;
};

export default function SourceInputDropdown(props: Props) {
    const [loading, setLoading] = useState<boolean>(false);
    const [selected, setSelected] = useState<string>(props.defaultValue);

    async function changeSourceInput(sourceId: string) {
        try {
            setSelected(sourceId);
            setLoading(true);
            await props.onChange(props.inputs.find((x) => x.getId() === sourceId)!);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Form.Field>
            <Form.Label>{props.label}</Form.Label>
            <Form.Control>
                <Form.Select
                    className="is-fullwidth"
                    loading={loading}
                    disabled={loading}
                    value={selected}
                    onChange={(el) => changeSourceInput(el.target.value)}>
                    {props.inputs.map((input) => (
                        <option key={input.getId()} value={input.getId()}>
                            {input.getName()}
                        </option>
                    ))}
                </Form.Select>
            </Form.Control>
        </Form.Field>
    );
}
